import Button from "shared/UI/Buttons/Button";
import { PositiveYouCard } from "../../Components/PositiveYouCard/PositiveYouCard";
import { PageHeader } from "UIPalette/PageHeader/PageHeader";
import { Column, Row } from "shared/UI/LayoutComponents/LayoutComponents";
import { JournalEntry, useGetAllJournalEntriesFunctionRequest } from "shared/request/myHealthyAdvantageApi";
import { ClientInfoState } from "shared/core/state/clientInfoState";
import { useNavigate } from "react-router-dom";
import { EntrySummaryCard } from "../../Components/EntrySummaryCard/EntrySummaryCard";
import { EntryChart } from "../../Components/EntryTracker/EntryChart";
import { JournalCalendar } from "./JournalCalendar";
import { useTranslation } from "react-i18next";
import { JournalLoader } from "../../Components/JournalLoader/JournalLoader";
import { useAppReviewContext } from "core/state/AppReviewContext/AppReviewContext";
import PageTitle from "UIPalette/PageTitle/PageTitle";
import { trackBtnClicks } from "core/monitoring/Events";
import { EventNames } from "core/monitoring/types/enums";

export const PositiveYouHome = () => {
  const today = new Date();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { handlePositiveMoment } = useAppReviewContext();
  const { data, isLoading } = useGetAllJournalEntriesFunctionRequest({
    xClientCode: ClientInfoState.getCode(),
  });

  if (isLoading) {
    return <JournalLoader />;
  }

  const todayEntry = data?.entries.find((entry) => entry.date === today.toDateOnlyString());

  const navigateToEntry = (entry: JournalEntry) => {
    handlePositiveMoment();
    navigate("entry", {
      state: entry,
    });
  };

  return (
    <div>
      <PageTitle title={t("pageTitle.positiveYou.home")} />
      <PageHeader />
      <Row>
        <Column>
          {todayEntry ? (
            <EntrySummaryCard {...todayEntry} onClick={() => navigateToEntry(todayEntry)} />
          ) : (
            <div className="space-y-6">
              <PositiveYouCard />
              <Button
                text={t("positiveYou.newEntryButtonTitle")}
                aria-label={t("positiveYou.newEntryButtonAria")}
                onClick={() => {
                  trackBtnClicks(EventNames.POSITIVE_YOU_NEW_ENTRY_CLICK);
                  navigate("create");
                }}
              />
            </div>
          )}
          <hr className="lg:hidden text-brand-grey-light" />
          <EntryChart />
        </Column>
        <Column>
          <JournalCalendar />
        </Column>
      </Row>
    </div>
  );
};
